import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hosp-management',
  templateUrl: './hosp-management.component.html',
  styleUrls: ['./hosp-management.component.scss']
})
export class HospManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
